/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { ListOperators } from '../models/ListOperators';

export class AppsCondition {
  'operator': ListOperators;
  'apps': Array<string>;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "operator",
      "baseName": "operator",
      "type": "ListOperators",
      "format": ""
    },
    {
      "name": "apps",
      "baseName": "apps",
      "type": "Array<string>",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return AppsCondition.attributeTypeMap;
  }

  public constructor() {
  }
}



